import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { DateTime } from 'luxon';

export enum StudentContactNoteMethod {
  EMAIL = 'E-Mail',
  SMS = 'SMS',
  WHATSAPP = 'Whatsapp',
  TELEPHONE = 'Telefon',
}

/**
 * @class StudentContactNote
 *
 * @description This class represents a note that was created by a user when contacting a student.
 */
@Entity()
export class StudentContactNote extends MongoEntity {
  public static override _class = 'StudentContactNote';
  public static override _collectionName = 'student_contact_notes';

  @validate(nonOptional())
  @Field(type => String)
  method: Maybe<StudentContactNoteMethod>;

  @DataLoadedField(type => Student, ({ studentID }) => studentID)
  student: Maybe<Student>;

  @validate(nonOptional())
  @Field(type => String)
  studentID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ contactUserID }) => contactUserID)
  contactUser: Maybe<ChancenwerkUser>;

  @validate(nonOptional())
  @Field(type => String)
  contactUserID: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  contactPersonType: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  note: Maybe<string>;

  @validate(nonOptional())
  @Field(type => DateTime)
  date: Maybe<DateTime>;
}

if (A.isServer) {
  const attendanceEventLogs = getRawCollection<any>(StudentContactNote._collectionName);

  // Create DB Indices
  void attendanceEventLogs.then(async db => {
    void db.createIndex({ studentID: 1 });
  });
}
